import styles from './style.module.scss';
import actionCreator from '../../../actioncreators/selfRegistration/request';
import applicationActionCreator from '../../../actioncreators/application';
import Translator from '../../../utils/translation/Translator';
import { EmailInput, ButtonContainer, PrimaryButton, SecondaryButton } from '../../../components';
import { withNamespace } from '../../../components/elements/textDisplays/TranslatedText';

import { StandardParagraph, Header2 } from '@idm/ui-components';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

const TranslatedText = withNamespace('SELF_REGISTRATION.REQUEST');
const requestDictionary = new Translator('SELF_REGISTRATION.REQUEST');

class Request extends Component {
  static propTypes = {
    formEmail: PropTypes.string.isRequired,
    isValidating: PropTypes.bool.isRequired,
    isAllValid: PropTypes.bool.isRequired,
    dictionary: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types

    dispatchResetState: PropTypes.func.isRequired,
    dispatchSetFormField: PropTypes.func.isRequired,
    dispatchSetFormFieldValidationResult: PropTypes.func.isRequired,
    dispatchSetFormIsValidating: PropTypes.func.isRequired,
    dispatchSelfRegistrationRequest: PropTypes.func.isRequired,
    onChangeUrl: PropTypes.func.isRequired,
  };

  componentDidUpdate(prevProps) {
    const { isValidating, isAllValid, dispatchSelfRegistrationRequest, formEmail } = this.props;

    if (this.shouldRequestSelfRegistration(prevProps.isValidating, isValidating, isAllValid)) {
      dispatchSelfRegistrationRequest(formEmail);
    }
  }

  componentWillUnmount() {
    const { dispatchResetState } = this.props;

    dispatchResetState();
  }

  shouldRequestSelfRegistration = (isFormSubmitted, isStillValidating, isAllValid) =>
    isFormSubmitted && !isStillValidating && isAllValid;

  goToLogin = () => {
    const { onChangeUrl } = this.props;

    onChangeUrl('/auth/login');
  };

  handleValidationChange(field, validationResult) {
    const { dispatchSetFormFieldValidationResult } = this.props;

    dispatchSetFormFieldValidationResult(field, validationResult);
  }

  handleEmailValidationChange = this.handleValidationChange.bind(this, 'email');

  handleKeyPress = (event) => {
    const { dispatchSetFormIsValidating } = this.props;

    if (event.key === 'Enter') {
      dispatchSetFormIsValidating();
    }
  };

  handleChange(field, event) {
    const { dispatchSetFormField } = this.props;

    dispatchSetFormField(field, event.target.value);
  }

  handleEmailChange = this.handleChange.bind(this, 'email');

  render() {
    const { dispatchSetFormIsValidating, formEmail, isValidating, dictionary } = this.props;
    const regex = new RegExp('^.+@.+\\..+$');
    const isValidEmail = regex.test(formEmail);

    return (
      <section>
        <Header2 className={styles.header2}>
          <TranslatedText i18nKey="HEADER" />
        </Header2>
        <StandardParagraph className={styles.displayMessage}>
          <TranslatedText i18nKey="BODY" />
        </StandardParagraph>
        <EmailInput
          forceValidationCheck={isValidating}
          handleValidationChange={this.handleEmailValidationChange}
          onChange={this.handleEmailChange}
          onKeyPress={this.handleKeyPress}
          value={formEmail}
          label={requestDictionary.get('EMAIL_LABEL', dictionary)}
          className="input-large"
          autoFocus={true}
          id="email-input"
          dataMetaId="email-input"
        />
        <ButtonContainer>
          <SecondaryButton
            onClick={this.goToLogin}
            value={requestDictionary.get('BACK', dictionary)}
            size="large"
            data-meta-id="cancel-button"
          >
            <TranslatedText i18nKey="CANCEL" />
          </SecondaryButton>
          <PrimaryButton
            onClick={dispatchSetFormIsValidating}
            size="large"
            data-meta-id="submit-button"
            disabled={!isValidEmail}
          >
            <TranslatedText i18nKey="SUBMIT" />
          </PrimaryButton>
        </ButtonContainer>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    formEmail: state.selfRegistrationRequest.form.email.value,
    isAllValid: state.selfRegistrationRequest.form.email.isValid,
    isValidating: state.selfRegistrationRequest.form.email.isValidating,
    dictionary: state.translation.main.dictionary,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeUrl(url) {
      applicationActionCreator.changeUrl(url);
    },
    dispatchResetState() {
      dispatch(actionCreator.resetState());
    },

    dispatchSetFormField(field, value) {
      dispatch(actionCreator.setFormField(field, value));
    },

    dispatchSetFormIsValidating() {
      dispatch(actionCreator.setFormIsValidating());
    },

    dispatchSetFormFieldValidationResult(field, validationResult) {
      dispatch(actionCreator.setFormFieldValidationResult(field, validationResult));
    },

    dispatchSelfRegistrationRequest(email) {
      dispatch(actionCreator.selfRegistrationRequest(email));
    },
  };
}

export { Request as UnwrappedSelfRegistrationRequest };
export default connect(mapStateToProps, mapDispatchToProps)(Request);
